import { Component, OnInit } from '@angular/core';
import { MetaDefinition } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { ImageOptimizerService } from '@sparro/app/core/helpers/image-optimizer';
import { MetaService } from '@sparro/app/core/helpers/meta/meta.service';

import { CompetitionService } from '@b2b/core/api/competition/competition.service';
import { CompDetailService } from '@b2b/core/api/detail/detail.service';
import { LeaderboardEntry } from '@sparro/app/core/models/leaderboard.model';
import { UNI_CONSTANTS } from '@sparro/core/config/constants.config';

@Component({
  selector: 'app-leaderboard',
  templateUrl: './leaderboard.component.html',
  styleUrls: ['./leaderboard.component.scss']
})
export class LeaderboardComponent implements OnInit {
  slug: string;
  isLoading: boolean = false;
  resultsAnnounced: boolean = false;
  shortlistedAnnounced: boolean = false;
  leaderboardEntries: LeaderboardEntry[] = [];
  competitionDeadlines = [];
  host: string = UNI_CONSTANTS.HOSTS.ARENA;

  constructor(
    public route: ActivatedRoute,
    public metaService: MetaService,
    public competitionService: CompetitionService,
    public imageOptimizer: ImageOptimizerService,
    public detailService: CompDetailService) { }

  ngOnInit(): void {
    this.slug = this.route.parent.snapshot.params.comp_slug;
    if (this.slug) {
      this.isLoading = true;
      this.getCompetitionSchedule();
      this.getLeaderboardEntries();
    }
  }

  getCompetitionSchedule(): void {
    this.detailService.scheduleModule(this.slug, 'schedule').subscribe(
      (result) => {
        this.competitionDeadlines = result[0].deadlines;
        this.checkDeadlines();
      }
    );
  }

  getLeaderboardEntries(): void {
    this.competitionService.getLeaderboardEntries(this.slug).subscribe(
      (result: LeaderboardEntry[]) => {
        this.leaderboardEntries = result;
        this.isLoading = false;
      }
    );
  }

  checkDeadlines(): void {
    this.competitionDeadlines.forEach((deadline) => {
      const today: any = new Date();
      if (deadline.deadline_type === 'SHORTLIST') {
        if (Date.parse(today) > Date.parse(deadline.date)) {
          this.shortlistedAnnounced = true;
        }
      }
      if (deadline.deadline_type === 'RESULT') {
        if (Date.parse(today) > Date.parse(deadline.date)) {
          this.resultsAnnounced = true;
        }
      }
    });
  }

  updateMetaInfo(): void {
    this.detailService.fetchCompetition(this.slug, (competition) => {
      let metaInfo: MetaDefinition[] = [];

      const title = `${competition.title} ${competition.disciplines[0]?.name} Competition | ` + (competition.location?.name ?
        competition.location.name : competition.location?.country?.name) + ` | Leaderboard`;
      const description = `View live status on leaderboard for the entries of ${competition.title} - ${competition.tagline}`;
      const image = competition.image ?  this.renderImage(competition.image) : '';
      metaInfo = [
        { name: 'title', content: title },
        { name: 'description', content: description },
        { name: 'url', content: window.location.href },
        { name: 'image', content: image },
        { name: 'twitter:card', content: 'summary_large_image' },
        { name: 'twitter:title', content: title },
        { name: 'twitter:description', content: description },
        { name: 'twitter:url', content: window.location.href },
        { name: 'twitter:image', content: image },
        { property: 'og:title', content: title },
        { property: 'og:description', content: description },
        { property: 'og:url', content: window.location.href },
        { property: 'og:image', content: image },
        { property: 'og:image:alt', content: title },
        { property: 'og:type', content: 'website' }
      ];
      metaInfo.forEach(meta => {
        this.metaService.updateMetaInfo(meta);
      });
      this.metaService.updateMeta(metaInfo);
      this.metaService.updateTitle(title);
      this.metaService.createCanonicalURL();
    });
  }

  renderImage(image: string): string {
    return this.imageOptimizer.renderImage(image, window.innerWidth, '');
  }
}
